module.exports = __webpack_public_path__ + "img/support-89def75e.svg";